import { render, staticRenderFns } from "./A3BoardCollectionPage.vue?vue&type=template&id=717954b0&"
import script from "./A3BoardCollectionPage.vue?vue&type=script&lang=ts&"
export * from "./A3BoardCollectionPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('717954b0')) {
      api.createRecord('717954b0', component.options)
    } else {
      api.reload('717954b0', component.options)
    }
    module.hot.accept("./A3BoardCollectionPage.vue?vue&type=template&id=717954b0&", function () {
      api.rerender('717954b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/A3/A3BoardCollectionPage.vue"
export default component.exports